import { AIAgentType } from "../../entities/company/AIBilling/AIBilling";
import { DashboardEntity } from "../../entities/company/Dashboard/DashboardEntity";
import CompanyService from "../../services/CompanyService";
import AgendaDrawer from "./components/AgendaDrawer";
import AgendaGate from "./components/AgendaGate";
import AgendaTodayCard from "./components/AgendaTodayCard";
import AgendaUnavailable from "./components/AgendaUnavailable";
import { useAgenda } from "./hooks/useAgenda";
import { getProgress, getTopPendingItems } from "./utils/agendaUtils";
import "./agenda.css";

const AgendaDashboardContent = ({ title }: { title?: string }) => {
  const state = useAgenda();
  const { agenda, items } = state;

  return (
    <div className="card agenda-dashboard">
      <div className="card-body">
        <AgendaGate state={state}>
          {agenda && (
            <AgendaTodayCard
              title={title}
              agenda={agenda}
              progress={getProgress(items)}
              topItems={getTopPendingItems(items)}
              canEdit={state.canEdit}
              onRegenerate={state.requestRegenerate}
              onToggleCompleted={state.requestToggleCompleted}
              onOpen={state.selectItem}
            />
          )}
        </AgendaGate>
        <AgendaDrawer
          item={state.selectedItem}
          canEdit={state.canEdit}
          onClose={state.clearSelection}
          onPrimaryAction={state.runPrimaryAction}
          onToggleCompleted={state.requestToggleCompleted}
          onDelete={state.requestDelete}
        />
      </div>
    </div>
  );
};

/**
 * Agenda dashboard panel: today's progress and top pending items. The
 * configured title replaces the default heading. The agenda API is only
 * queried when the Agenda agent is enabled for the company.
 */
const AgendaDashboard = ({ dashboard }: { dashboard: DashboardEntity }) => {
  if (!CompanyService.canShowAgentAI(AIAgentType.Agenda)) {
    return (
      <div className="card">
        <div className="card-body">
          <AgendaUnavailable />
        </div>
      </div>
    );
  }
  return <AgendaDashboardContent title={dashboard.Title} />;
};

export default AgendaDashboard;
